export const AGENT_NAMES = {
  general: 'general',
  postAgent: 'post-agent',
  generalAgent: 'general-agent'
} as const

export type AgentName = (typeof AGENT_NAMES)[keyof typeof AGENT_NAMES]

export const ACTION_ID_TO_AGENT: Record<string, string> = {
  'post-agent': AGENT_NAMES.postAgent
}

export const GUIDE_ACTION_IDS_WITH_SPECIALIST: string[] = ['ofrecer-servicios']
